import { NgModule } from '@angular/core';
import { SettingsUsersSyncModule } from './users-sync/users-sync.module';

@NgModule({
  imports: [
    SettingsUsersSyncModule
  ]
})
export class UsersModule { }
